var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiniconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4H12.5C12.5 2.89543 11.6046 2 10.5 2C9.39543 2 8.5 2.89543 8.5 4ZM7 4C7 2.067 8.567 0.5 10.5 0.5C12.433 0.5 14 2.067 14 4H19.75C20.1642 4 20.5 4.33579 20.5 4.75C20.5 5.16421 20.1642 5.5 19.75 5.5H18.4309L17.2589 17.6112C17.0729 19.5334 15.4575 21 13.5263 21H7.47369C5.54254 21 3.92715 19.5334 3.74113 17.6112L2.56908 5.5H1.25C0.835786 5.5 0.5 5.16421 0.5 4.75C0.5 4.33579 0.835786 4 1.25 4H7ZM9 8.75C9 8.33579 8.66421 8 8.25 8C7.83579 8 7.5 8.33579 7.5 8.75V16.25C7.5 16.6642 7.83579 17 8.25 17C8.66421 17 9 16.6642 9 16.25V8.75ZM12.75 8C13.1642 8 13.5 8.33579 13.5 8.75V16.25C13.5 16.6642 13.1642 17 12.75 17C12.3358 17 12 16.6642 12 16.25V8.75C12 8.33579 12.3358 8 12.75 8ZM5.23416 17.4667C5.34577 18.62 6.315 19.5 7.47369 19.5H13.5263C14.685 19.5 15.6542 18.62 15.7658 17.4667L16.9239 5.5H4.07608L5.23416 17.4667Z",
    fill: "#F44848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiniconRed);
export default __webpack_public_path__ + "static/media/binicon-red.087ea9f786ab52b038d960da4596b654.svg";
export { ForwardRef as ReactComponent };